import { render, staticRenderFns } from "./DPayment.vue?vue&type=template&id=b000099e&"
import script from "./DPayment.vue?vue&type=script&lang=js&"
export * from "./DPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports